import React, { useState, useEffect } from 'react';
import { CONSTANTS } from '../../data';

interface LoadingScreenProps {
  onComplete: () => void;
}

export const LoadingScreen: React.FC<LoadingScreenProps> = ({ onComplete }) => {
  const [loadingProgress, setLoadingProgress] = useState(0);
  const [loadingMessageIndex, setLoadingMessageIndex] = useState(0);

  useEffect(() => {
    const totalDuration = CONSTANTS.LOADING_SCREEN.durationMs;
    const updateInterval = CONSTANTS.LOADING_SCREEN.updateIntervalMs;
    const messageInterval = CONSTANTS.LOADING_SCREEN.messageIntervalMs;
    
    let progress = 0;
    let messageIndex = 0;
    
    const progressTimer = setInterval(() => {
      progress += (updateInterval / totalDuration) * 100;
      setLoadingProgress(Math.min(progress, 100));
      
      if (progress >= 100) {
        clearInterval(progressTimer);
        setTimeout(() => {
          onComplete();
        }, 500);
      }
    }, updateInterval);

    const messageTimer = setInterval(() => {
      messageIndex = (messageIndex + 1) % CONSTANTS.LOADING_SCREEN.messages.length;
      setLoadingMessageIndex(messageIndex);
    }, messageInterval);

    return () => {
      clearInterval(progressTimer);
      clearInterval(messageTimer);
    };
  }, [onComplete]);

  return (
    <div className="loading-screen">
      <div className="loading-container">
        <div className="loading-title">
          {CONSTANTS.LOADING_SCREEN.title}
        </div>
        
        <div className="loading-subtitle">
          {CONSTANTS.LOADING_SCREEN.subtitle}
        </div>

        <div className="loading-progress-container">
          <div className="loading-progress-bar">
            <div 
              className="loading-progress-fill"
              style={{ width: `${loadingProgress}%` }}
            />
            <div className="loading-scan-line" />
          </div>
          <div className="loading-percentage">
            {Math.floor(loadingProgress)}%
          </div>
        </div>

        <div className="loading-message">
          {CONSTANTS.LOADING_SCREEN.messages[loadingMessageIndex]}
        </div>

        <div className="loading-dots">
          <div className="loading-dot" />
          <div className="loading-dot" />
          <div className="loading-dot" />
        </div>
      </div>
    </div>
  );
};
